import api from "../../../../services/api"

// Ações da entrega Flux no painel (sistemaadm: FluxDeliveryResource, /rest/flux/entrega/...).
// Todas exigem o Authorization do usuário (o pedido tem de ser de uma loja dele). As funções
// devolvem { data } como o axios; em falha, data traz { sucesso: false, mensagem } com a mensagem
// do backend quando houver (em vez do genérico "Request failed with status code ...").

const headers = autorizacao => ({
    "Content-Type": "application/json",
    Authorization: autorizacao,
})

const mensagemDoErro = (error, padrao) =>
    error?.response?.data?.mensagem ||
    (error?.response
        ? `${padrao} (erro ${error.response.status} no servidor)`
        : error?.message === "Network Error"
        ? "Verifique sua conexão!"
        : error?.message || padrao)

const post = async (caminho, autorizacao, padrao) => {
    try {
        return await api.post(caminho, {}, { headers: headers(autorizacao) })
    } catch (error) {
        return { data: { sucesso: false, mensagem: mensagemDoErro(error, padrao) } }
    }
}

// Tudo o que o popup precisa numa chamada só: { detalhes, situacao, codigos, status }.
// atualizar=true consulta o último status e os códigos direto na Flux ("Atualizar").
export const buscarPainelEntregaFlux = async (idDoPedido, autorizacao, atualizar = false) => {
    try {
        return await api.get(`flux/entrega/painel/${idDoPedido}`, {
            headers: headers(autorizacao),
            params: { atualizar },
        })
    } catch (error) {
        return {
            data: { erro: mensagemDoErro(error, "Falha ao carregar a entrega na Flux") },
        }
    }
}

// Reenvia a entrega à Flux na hora (síncrono) e devolve a situação resultante {sucesso, mensagem}.
export const reenviarEntregaFlux = (idDoPedido, autorizacao) =>
    post(`flux/entrega/reenviar/${idDoPedido}`, autorizacao, "Falha ao reenviar")

// Aciona um NOVO entregador na Flux na hora (síncrono) — usado no acionamento manual ou quando o
// entregador anterior cancelou. Cria uma nova solicitação e ignora o tempo de preparo.
export const acionarNovoEntregadorFlux = (idDoPedido, autorizacao) =>
    post(`flux/entrega/novo-entregador/${idDoPedido}`, autorizacao, "Falha ao acionar entregador")

// Cancela a entrega na Flux (síncrono) e devolve {sucesso, mensagem}.
export const cancelarEntregaFlux = (idDoPedido, autorizacao) =>
    post(`flux/entrega/cancelar/${idDoPedido}`, autorizacao, "Falha ao cancelar a entrega")
